<template>
  <div class="content-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/dashboard' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>Campaign列表</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="panel mt-20">
      <div class="filter">
        <el-form :model="filter" label-position="left" label-width="50px" size="small">
          <div class="filter-block">
            <el-form-item label="名称">
              <el-input size="small" v-model="filter.name"></el-input>
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model="filter.tag_id" placeholder="请选择" clearable style="width: 100%">
                <el-option :value="k" :key="k" :label="v" v-for="(v, k) in campaignTagMap"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label-width="0px">
              <el-button
                type="primary"
                size="small"
                @click="
                  filter.page = 1
                  requestCampaignList()
                "
                >筛选</el-button
              >
              <el-button size="small" @click="reset()">重置</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </div>
    <div class="panel mt-20">
      <el-table :data="lists" stripe>
        <el-table-column prop="name" label="名称" min-width="120"> </el-table-column>
        <el-table-column label="类型" align="center" min-width="100">
          <template slot-scope="scope">
            <el-tag type="primary" size="mini" v-if="scope.row.tag_id">{{ campaignTagMap[scope.row.tag_id] }}</el-tag>
            <span v-else>无</span>
          </template>
        </el-table-column>
        <el-table-column prop="leads_count" label="Leads数量" align="center">
          <template slot-scope="scope">
            <router-link :to="`/dashboard/leads?campaign_id=${scope.row.id}`"> {{ scope.row.leads_count }}</router-link>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template slot-scope="scope">
            <el-button type="primary" class="mr-5" size="mini" plain @click="handleEditModel(scope.row, scope.$index)">编辑类型</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination class="mt-20" :page-size="filter.size" :current-page.sync="filter.page" layout="total, prev, pager, next" :total="total"></el-pagination>
    </div>

    <el-dialog title="编辑Campaign类型" :visible.sync="visible" width="500px">
      <el-form :model="editModel" label-width="60px" size="small">
        <el-form-item label="名称" prop="name">
          <el-input v-model="editModel.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="tag">
          <el-select v-model="editModel.tag_id" placeholder="请选择" clearable style="width: 100%">
            <el-option :value="parseInt(k)" :key="k" :label="v" v-for="(v, k) in campaignTagMap"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="handleUpdateCampaign" size="small">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { campaignList, updateCampaign } from '@/service/getData'
export default {
  data() {
    return {
      filter: {
        name: '',
        size: 10,
        page: 1,
        tag_id: '',
      },
      lists: [],
      total: 0,
      editModel: {},
      editIndex: 0,
      visible: false,
      campaignTagMap: {
        0: '无',
        // 1: 'SALES CAMPAIGN（报价）',
        2: 'SERVICE DUE LEADS CAMPAIGN（保养）',
        // 3: 'RETENTION LEADS CAMPAIGN（无重复业务）',
        4: 'BUSINESS OPPORTUNITY LEADS CAMPAIGN（商机）',
      },
    }
  },
  watch: {
    'filter.page': function() {
      this.requestCampaignList()
    },
  },
  created() {
    this.requestCampaignList()
  },
  methods: {
    async requestCampaignList() {
      let data = this.clone(this.filter)
      data.page -= 1

      let res = await campaignList(data)

      this.lists = res.data.list
      this.total = res.data.total
    },
    handleEditModel(item, index) {
      this.editModel = this.clone(item)
      this.editIndex = index
      this.visible = true
    },
    async handleUpdateCampaign() {
      let res = await updateCampaign({
        id: this.editModel.id,
        tag_id: this.editModel.tag_id || 0,
      })
      if (res.code == 0) {
        this.lists[this.editIndex].tag_id = res.data.tag_id
        this.visible = false
      }
    },
    reset() {
      this.filter.page = 1
      this.filter.name = ''
      this.filter.tag_id = ''
      this.requestCampaignList()
    },
  },
}
</script>
